import { render, staticRenderFns } from "./VerticalNavMenuItems.vue?vue&type=template&id=420927aa&"
import script from "./VerticalNavMenuItems.vue?vue&type=script&lang=js&"
export * from "./VerticalNavMenuItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports